/* eslint-disable */
import HttpClient from "../../shared-module/utilities/http-client";

const { ProtectedHttpClient } = HttpClient;

const MessagingServiceApi = {
  public: {},
  private: {
    /**
     * To fetch all available phone numbers for a specific practice/clinic
     * @param {*} selectedPracticeId
     * @returns
     */
    fetchPhoneNumbers: selectedPracticeId => ProtectedHttpClient.get(`/practice/smssendphonenumbers/${selectedPracticeId}`),
    /**
     *  To fetch all messaging services for a specific practice/clinic
     * @param {*} selectedPracticeId
     * @returns
     */
    fetchServices: selectedPracticeId => ProtectedHttpClient.get(`/practice/messagingservices/${selectedPracticeId}`),
    /**
     *  To add a new messaging service to a specific practice/clinic
     * @param {*} payload
     * @returns
     */
    addService: payload => ProtectedHttpClient.post(`/messagingservices`, payload),
    /**
     *  To update a new messaging service
     * @param {*} payload
     * @returns
     */
    updateService: payload => ProtectedHttpClient.put(`/messagingservices`, payload),
    /**
     *  To delete a messaging service
     * @param {*} selectedPracticeId
     * @returns
     */
    deleteService: selectedPracticeId => ProtectedHttpClient.delete(`/messagingservices/${selectedPracticeId}`),
    /**
     *  To fetch all the available phone numbers for a clinic
     * @param {*} payload
     * @returns
     */
    getAvailableTwilioNumbers: ({ practiceId, phoneType, zipCode }) => ProtectedHttpClient.get(
        `/availabletwiliophonenumbers/${practiceId}/${phoneType}/${zipCode}`
      ),
    /**
     *  To add a phone number to a clinic
     * @param {*} payload
     * @returns
     */
    provisionTwilioNumber: payload => ProtectedHttpClient.post(`/provisiontwilionumber`, payload),
    /**
     *  To add a phone number to a clinic
     * @param {*} payload
     * @returns
     */
    addTwilioNumber: payload => ProtectedHttpClient.post(`/senderpn`, payload),
    /**
     *  To add a messaging service
     * @param {*} payload
     * @returns
     */
    addMessagingServices: payload => ProtectedHttpClient.post(`/messagingservice`, payload),
    /**
     *  To update a messaging service
     * @param {*} payload
     * @returns
     */
    updateMessagingService: payload => ProtectedHttpClient.put(`/messagingservices`, payload),
    /**
     *  To deploy a number
     * @param {*} payload
     * @returns
     */
    deployNumber: (payload) => ProtectedHttpClient.post(`/senderpn`, payload),
    /**
     *  To deploy a number
     * @param {*} pnSID
     * @returns
     */
    removeNumber: (pnSID) => ProtectedHttpClient.post(`/removepn`, pnSID),
    /**
    *  To deploy a number
    * @param {*} pnSID
    * @returns
    */
    removeMessagingService: (pnSID) => ProtectedHttpClient.post(`/removems`, pnSID)
  }
};
export default MessagingServiceApi;
